import { createAsyncThunk } from '@reduxjs/toolkit';
import { InvoiceScannerAPI } from '../../helpers/firebase_helper';

// Thunk 1: Request pre-signed URL from backend
export const requestPresignedUrl = createAsyncThunk(
  'invoice/requestPresignedUrl',
  async ({ fileName, fileType, fileSize }, { rejectWithValue }) => {
    try {
      const result = await InvoiceScannerAPI.requestPresignedUrl(
        fileName,
        fileType,
        fileSize
      );
      return result;
    } catch (error) {
      console.log(error);
      
      return rejectWithValue(
        error.response?.data?.message || 'Failed to get upload URL'
      );
    }
  }
);

// Thunk 2: Upload file to S3 using pre-signed URL
export const uploadFileToS3 = createAsyncThunk(
  'invoice/uploadFileToS3',
  async ({ file, preSignedUrl }, { rejectWithValue, dispatch }) => {
    try {
      const result = await InvoiceScannerAPI.uploadToS3(
        preSignedUrl,
        file,
        (progressEvent) => {
          const progress = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          dispatch({ type: 'invoice/uploadProgress', payload: progress });
        }
      );
      return result;
    } catch (error) {
      console.log(error);
      
      return rejectWithValue(
        error.response?.data?.message || 'Failed to upload file to S3'
      );
    }
  }
);

// Thunk 3: Fetch invoice data
export const fetchInvoiceData = createAsyncThunk(
  'invoice/fetchInvoiceData',
  async ({ correlationId }, { rejectWithValue }) => {
    try {
      const result = await InvoiceScannerAPI.fetchInvoiceData(correlationId);
      return result;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to fetch invoice data'
      );
    }
  }
);

// Thunk 4: Fetch all uploaded invoices
export const fetchUploadedInvoices = createAsyncThunk(
  'invoice/fetchUploadedInvoices',
  async ({ itemsPerPage, offset }, { rejectWithValue }) => {
    try {
      const invoices = await InvoiceScannerAPI.getAllInvoices(itemsPerPage, offset);
      return invoices;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to fetch uploaded invoices'
      );
    }
  }
);

// Thunk 5: Delete invoice
export const deleteInvoice = createAsyncThunk(
  'invoice/deleteInvoice',
  async ({ invoiceId }, { rejectWithValue }) => {
    try {
      const result = await InvoiceScannerAPI.deleteInvoice(invoiceId);
      return result;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to delete invoice'
      );
    }
  }
);

// Thunk 6: Download invoice
export const downloadInvoice = createAsyncThunk(
  'invoice/downloadInvoice',
  async ({ invoiceId, fileName }, { rejectWithValue }) => {
    try {
      const blob = await InvoiceScannerAPI.downloadInvoice(invoiceId);
      
      // Create download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      return { invoiceId };
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to download invoice'
      );
    }
  }
);

// Thunk 7: Get download URL (alternative approach)
export const getDownloadUrl = createAsyncThunk(
  'invoice/getDownloadUrl',
  async ({ invoiceId }, { rejectWithValue }) => {
    try {
      const downloadUrl = await InvoiceScannerAPI.getDownloadUrl(invoiceId);
      return { invoiceId, downloadUrl };
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to get download URL'
      );
    }
  }
);
